import axios from 'axios';

export default {
    install: (app) => {
        const api = axios.create({
            baseURL: process.env.VUE_APP_API_BASE_URL,
            timeout: process.env.VUE_APP_API_TIMEOUT || 10000,
            headers: {
                'Content-Type': 'application/json',
            },
        });

        // Interceptor request
        api.interceptors.request.use(
            (config) => {
                // const token = localStorage.getItem('token');
                // if (token) {
                //     config.headers.Authorization = `Bearer ${token}`;
                // }
                return config;
            },
            (error) => Promise.reject(error)
        );

        // Interceptor response
        api.interceptors.response.use(
            (response) => response.data,
            (error) => {
                // if (error.response?.status === 401) {
                //     localStorage.removeItem('token');
                //     window.location.href = '/login';
                // }
                return Promise.reject(error);
            }
        );

        // 🔑 daftar ke global biar bisa diakses pakai this.$axios
        app.config.globalProperties.$axios = api;

        // Optional: kalau mau inject via provide/inject
        app.provide('axios', api);
    },
};
